import React from "react";
import { useFavoriteMarkets, useFavoriteMarketsDispatch } from "./FavoriteMarkets";
import Img from "../Img";

export default function FavoritesMarketToggle(props) {
    const favorites = useFavoriteMarkets();
    const dispatch = useFavoriteMarketsDispatch();

    function handleClick(e) {
        e.preventDefault();
        e.stopPropagation();
        dispatch({
            type: 'toggle',
            id: props.id
        });
    }

    const src = favorites && favorites[props.id] != null ? 'Favs_active.svg' : 'Favs_default.svg';
    
    return (
        <Img className="c_21_1_1" src={src} height="16px" width="16px" onClick={handleClick} />
    );
}
